import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Box } from '@mui/system';
import React, { ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useSearchParams from '../../hooks/useSearchParams';
import { getProductCategories, listProductCategories } from '../../redux/slices/products/productsSlice';
import { useDispatch } from '../../redux/store';

// Products with no category report as "Other" from the API, so the option list
// is the categories plus that bucket. The filter is by name, not id, for the
// same reason: "Other" has no id to send.
export const OTHER_CATEGORY = 'Other';

type ProductCategoryFilterProps = {
  viewMode?: boolean;
  fullWidth?: boolean;
};

export default function ProductCategoryFilter({ viewMode, fullWidth }: ProductCategoryFilterProps): ReactElement {
  const dispatch = useDispatch();
  const categories = useSelector(getProductCategories);
  const [params, setURLParams] = useSearchParams();

  useEffect(() => {
    dispatch(listProductCategories());
  }, [dispatch]);

  const options = [...(categories || []).map((category) => category.name || '').filter(Boolean), OTHER_CATEGORY];

  return viewMode ? (
    <React.Fragment>
      {params.productCategory && (
        <Box component="span">
          Category: <strong>{params.productCategory}</strong>
        </Box>
      )}
    </React.Fragment>
  ) : (
    <FormControl fullWidth {...(!fullWidth && { sx: { width: 150 } })}>
      <InputLabel id="productCategory">Category</InputLabel>
      <Select
        labelId="productCategory"
        defaultValue={params.productCategory || -1}
        label="Category"
        onChange={(event) => {
          setURLParams({
            newParams: { productCategory: event.target.value === -1 ? '' : event.target.value },
          });
        }}
        size="small"
      >
        <MenuItem value={-1}>All</MenuItem>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
